import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { AuditOperation, AuditOperationFilters, AuditOperationStatusEnum, AuditOperationStepTypeEnum } from './audits-operation.model';


export interface AuditOperationState {
  status?: AuditOperationStatusEnum;
  step?: AuditOperationStepTypeEnum;
  filters: AuditOperationFilters;
}


export const auditsOperationStore = createStore(
  { name: 'audits-operation' },
  withEntities<AuditOperation>(),
  withProps<AuditOperationState>({
    step: AuditOperationStepTypeEnum.AUDIT,
    filters: {search: '', tableFilters: AuditOperationFilters.initTableFilters()},
  }),
  withRequestsStatus()
);
